











































































































































































import Vue from "vue";
import { uuid } from "@/utils/uuid";
import TaskEdit from "@/components/PrjTask/TaskEdit.vue";
import TaskInfo from "@/components/PrjTask/TaskInfo.vue";
import { Header } from "@/components/MyTable.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import { eventBus } from "../utils/event";
import { axios } from "../plugins";

const TaskHeaders: Header[] = [
  { title: "任务名称", key: "" },
  { title: "状态", key: "" },
  { title: "上次执行时间", key: "", minWidth: 180 },
  { title: "操作", key: "", width: 100 }
];

const ScheduledTaskHeaders: Header[] = [
  { title: "任务名称", key: "" },
  { title: "状态", key: "" },
  { title: "定时计划", key: "" },
  { title: "上次执行时间", key: "", minWidth: 180 },
  { title: "操作", key: "", width: 100 }
];

const Tabs = [
  { label: "任务", name: "Task", uuid: uuid() },
  { label: "定时任务", name: "ScheduledTask", uuid: uuid() }
];

export default Vue.extend({
  name: "PrjTask",
  components: { TaskEdit, TaskInfo },
  props: { projectId: { type: String } },
  data() {
    return {
      tabActive: "Task",
      Tabs,
      TaskHeaders,
      ScheduledTaskHeaders,
      disabled: false
    };
  },
  computed: {
    ...mapState("PrjTask/Task", {
      taskPageNum: "pageNum",
      taskTotal: "total",
      taskHasNext: "hasNext",
      taskPageSize: "pageSize"
    }),
    ...mapState("PrjTask/ScheduledTask", {
      scheduledTaskPageNum: "pageNum",
      scheduledTaskTotal: "total",
      scheduledTaskHasNext: "hasNext",
      scheduledTaskPageSize: "pageSize"
    }),
    ...mapGetters("PrjTask/Task", { taskTableData: "tableData" }),
    ...mapGetters("PrjTask/ScheduledTask", {
      scheduledTaskTableData: "tableData"
    })
  },
  watch: {
    projectId: {
      immediate: true,
      handler() {
        if (this.tabActive === "Task") {
          this.taskGetData({ url: `/jobs/${this.projectId}` });
        } else {
          this.scheduledTaskGetData({ url: `/cronJobs/${this.projectId}` });
        }
      }
    },
    tabActive(val) {
      if (val === "Task") {
        this.taskClear();
        this.taskGetData({ url: `/jobs/${this.projectId}` });
      } else {
        this.scheduledTaskClear();
        this.scheduledTaskGetData({ url: `/cronJobs/${this.projectId}` });
      }
    }
  },
  beforeDestroy() {
    this.taskClear();
    this.scheduledTaskClear();
  },
  methods: {
    ...mapActions("PrjTask/Task", {
      taskGetData: "getData",
      taskDelete: "delete",
      taskSetData: "setData",
      taskPageTurn: "pageTurn",
      taskClear: "clear"
    }),
    ...mapActions("PrjTask/ScheduledTask", {
      scheduledTaskGetData: "getData",
      scheduledTaskDelete: "delete",
      scheduledTaskSetData: "setData",
      scheduledTaskPageTurn: "pageTurn",
      scheduledTaskClear: "clear"
    }),
    turnPage(page: number) {
      this.disabled = true;
      let url = `/jobs/${this.projectId}`;
      if (this.tabActive != "Task") {
        url = `/cronJobs/${this.projectId}`;
        this.scheduledTaskPageTurn({ page, url }).finally(() => {
          this.disabled = false;
        });
      } else {
        this.taskPageTurn({ page, url }).finally(() => {
          this.disabled = false;
        });
      }
    },
    taskSearch(name: any) {
      const url = { header: "jobs", tail: "job" };
      if (this.tabActive != "Task") {
        url.header = "cronJobs";
        url.tail = "cronJob";
      }
      if (name) {
        if (this.tabActive == "Task") {
          axios
            .get(`/${url.header}/${this.projectId}/${url.tail}/${name}`)
            .then(res => {
              this.taskSetData({
                list: [res.data.data],
                pageNum: 1,
                total: 1
              });
            })
            .catch(() => {
              this.taskSetData({
                list: [],
                pageNum: 1,
                total: 0,
                pages: 0
              });
            });
        } else {
          axios
            .get(`/${url.header}/${this.projectId}/${url.tail}/${name}`)
            .then(res => {
              this.scheduledTaskSetData({
                list: [res.data.data],
                pageNum: 1,
                total: 1
              });
            })
            .catch(() => {
              this.scheduledTaskSetData({
                list: [],
                pageNum: 1,
                total: 0,
                pages: 0
              });
            });
        }
      } else {
        if (this.tabActive == "Task") {
          this.taskGetData({ url: `/${url.header}/${this.projectId}` });
        } else {
          this.scheduledTaskGetData({
            url: `/${url.header}/${this.projectId}`
          });
        }
      }
    },
    handleCommand(type: string, data: any, timer = false) {
      switch (type) {
        case "edit":
          this.create(data);
          break;

        case "delete":
          this.del(data.metadata.name);
          break;
        case "play":
          this.play(data, timer);
          break;
        case "stop":
          this.stop(data);
          break;
      }
    },
    play(data: any, timer: boolean) {
      if (timer) {
        this.stop(data, false);
      } else {
        axios
          .post(
            `/jobs/${this.projectId}/job/${data.metadata.name}/rerun?resourceVersion=${data.metadata.resourceVersion}`
          )
          .then(() => {
            this.$message.success("任务开始执行");
            this.taskGetData({ url: `/jobs/${this.projectId}` });
          });
      }
    },
    stop(data: any, suspend = true) {
      axios
        .patch(
          `/cronJobs/${this.projectId}/cronJob/${data.metadata.name}/suspend/${suspend}`
        )
        .then(() => {
          if (suspend) {
            this.$message.success("任务执行已暂停");
          } else {
            this.$message.success("任务开始执行");
          }
          this.scheduledTaskGetData({ url: `/cronJobs/${this.projectId}` });
        });
    },
    create(data: any) {
      // eventBus.$emit("setBeard", {
      //   name: data ? "编辑任务" : "创建任务",
      //   callback: () => {
      //     (this.$refs.task as any).close();
      //   }
      // });
      (this.$refs.task as any).show(data);
    },
    del(name: string) {
      this.$confirms({ title: `删除 ${name}` }).then(() => {
        let url = "",
          getDataUrl = "";

        if (this.tabActive === "Task") {
          url = `/jobs/${this.projectId}/job/${name}`;
          getDataUrl = `/jobs/${this.projectId}`;
          this.taskDelete({ url, getDataUrl })
            .then(() => {
              this.$message.success("任务刪除成功");
            })
            .catch(e => {
              this.$message.error(e);
            });
        } else {
          url = `/cronJobs/${this.projectId}/cronJob/${name}`;
          getDataUrl = `/cronJobs/${this.projectId}`;
          this.scheduledTaskDelete({ url, getDataUrl })
            .then(() => {
              this.$message.success("任务刪除成功");
            })
            .catch(e => {
              this.$message.error(e);
            });
        }
      });
    },
    search(value: string) {
      this.taskSearch(value);
    },
    showTask(data: any) {
      this.tabActive = "SubTask";
      this.$nextTick(() => {
        (this.$refs.TaskInfo as any)?.show(data);
      });
    },
    // 查看任务详情
    showTaskInfo(data: any) {
      eventBus.$emit("setBeard", {
        name: "任务详情",
        callback: () => {
          (this.$refs.TaskInfo as any).close();
          this.tabActive = "Task";
        }
      });
      (this.$refs.TaskInfo as any)?.show(data);
    },
    getStatus(data: any) {
      let _status = "启动";

      if (!data.status) {
        return "Failed";
      }
      if (data.status.conditions) {
        (data.status.conditions as any[]).some(item => {
          if (item.type === "Failed" && item.status === "True") {
            _status = "Failed";
            return true;
          }

          if (item.type === "Complete" && item.status === "True") {
            _status = "Complete";
            return true;
          }

          return false;
        });
        return _status;
      }
      if (data.spec.Completions <= data.status.Succeed) _status = "Failed";

      return _status;
    }
  }
});
